import { Card, CardActions, CardContent, CircularProgress, Grid, Typography } from "@mui/material"
import React from "react"
import SimpleTable from "../../components/Common/Elements"
import { useIsCheaterV1TohQuery } from "../../core/api/toh-social-api"
import TohBanControl from "./TohBanControl"
import TohUnbanControl from "./TohUnbanControl"
import TohGrantAmnestyControl from "./TohGrantAmnestyControl"
import TohRevokeAmnestyControl from "./TohRevokeAmnestyControl"

const TohBanStatusCard = ({ userId }) => {
    const { data, isLoading, isFetching } = useIsCheaterV1TohQuery(
        userId,
        { skip: userId === "" }
    )

    return (
        <Card>
            <CardContent>
                <Typography
                    sx={{
                        pb: 2,
                        fontSize: 16
                    }}>
                    Ban Status
                </Typography>
                {
                    isLoading || isFetching
                        ? (
                            <CircularProgress />
                        )
                        : (
                            <SimpleTable
                                data={[
                                    ["Server Ban", data?.cheater?.toString() ?? "N/A"],
                                    ["Reason", data?.reasons?.join(", ") || "N/A"]
                                ]}
                            />
                        )
                }
            </CardContent>
            <CardActions disableSpacing>
                <Grid container spacing={1}>
                    <Grid size={6}>
                        <TohBanControl disabled={isLoading || isFetching} userId={userId} />
                    </Grid>
                    <Grid size={6}>
                        <TohUnbanControl disabled={isLoading || isFetching} userId={userId} />
                    </Grid>
                    <Grid size={6}>
                        <TohGrantAmnestyControl disabled={isLoading || isFetching} userId={userId} />
                    </Grid>
                    <Grid size={6}>
                        <TohRevokeAmnestyControl disabled={isLoading || isFetching} userId={userId} />
                    </Grid>
                </Grid>
            </CardActions>
        </Card>
    );
}

export default TohBanStatusCard
